import type { Path } from "./types";
import { WILDCARD } from "./types";

/** Structural equality for Paths. `===` on arrays is a reference check. */
const pathEquals = (a: Path, b: Path): boolean => a.length === b.length && a.every((seg, ix) => seg === b[ix]);

/**
 * Stable key for Map/Set use. `toString()` is unsafe: [null] and [""] both
 * stringify to "", and ["a/b"] collides with ["a", "b"].
 */
const pathKey = (p: Path): string => JSON.stringify(p.map((seg) => (seg === WILDCARD ? null : seg)));

/**
 * Top-level folder of a path, with trailing slash: "a/b/c.json" -> "a/".
 * A path with no slash is its own top level, e.g. "index.html" -> "index.html".
 */
const topLevel = (path: string): string => {
  const ix = path.indexOf("/");
  return ix < 0 ? path : path.slice(0, ix + 1);
};

export { pathEquals, pathKey, topLevel };
